module.exports = __webpack_public_path__ + "static/media/vision.187434b8.svg";